export { default } from './IconList';
export type { Props, Props as IconListProps, Item } from './IconList';
